// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:768px) and (max-width:991px){.home._resumen[data-v-9358f2d2]{min-height:100vh!important}}", ""]);
// Exports
module.exports = exports;
